"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _mobxReact = require("mobx-react");

var _classnames = _interopRequireDefault(require("classnames"));

var _filter = _interopRequireDefault(require("lodash/filter"));

var _noop = _interopRequireDefault(require("lodash/noop"));

var _a11y = require("../../../util/a11y");

var _TabbedSectionModel = _interopRequireDefault(require("../../models/TabbedSectionModel"));

var _ActionRoot = require("../../../higher-order/ActionRoot");

var _class, _class2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TabbedSection = (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
  _inherits(TabbedSection, _React$Component);

  var _super = _createSuper(TabbedSection);

  function TabbedSection() {
    _classCallCheck(this, TabbedSection);

    return _super.apply(this, arguments);
  }

  _createClass(TabbedSection, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.model.updateAnchorMap((0, _filter.default)(this.props.children, function (child) {
        return child && child.type === TabbedSection.Tab;
      }));
      this.props.model.updateHistory();
    }
  }, {
    key: "setActiveTab",
    value: function setActiveTab(tab) {
      var model = this.props.model;

      if (!tab.props.isDisabled) {
        model.changeTab(tab.props.index, false, tab.props.anchor ? "#" + tab.props.anchor : null);

        if (tab.props.anchor) {
          window.location.href = window.location.href.split("#")[0] + "#" + tab.props.anchor;
        }

        if (this.props.onChangeTab) {
          this.props.onChangeTab(tab.props.index);
        } // for hooks


        this.context.dispatcher.emit("SET_ACTIVE_TAB", {
          tabIndex: tab.props.index
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var classes = (0, _classnames.default)(this.props.className, "tabbed-section");
      var model = this.props.model;

      var body = /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)("tabbed-section-body")
      }, _react.default.Children.map(this.props.children, function (child) {
        if (child && child.type === TabbedSection.Panel && model.activeTab === child.props.index) {
          return child;
        }

        return null;
      }));

      return /*#__PURE__*/_react.default.createElement("div", {
        className: classes
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "tabbed-section-nav"
      }, /*#__PURE__*/_react.default.createElement("ul", null, this.props.model.showArrows && /*#__PURE__*/_react.default.createElement(_a11y.Buttonize, {
        onClick: this.props.model.previousTab,
        label: "Navigate to Previous Tab"
      }, /*#__PURE__*/_react.default.createElement("li", {
        className: "arrow prev-tab"
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "icon-left-open"
      }))), _react.default.Children.map(this.props.children, function (child) {
        var isActive = child && model.activeTab === child.props.index;

        if (child && child.type === TabbedSection.Tab && !child.props.hidden) {
          return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.cloneElement(child, {
            isActive: isActive,
            onClick: _this.setActiveTab.bind(_this, child)
          }), isActive && _this.props.renderBodyAsListItem && /*#__PURE__*/_react.default.createElement("li", {
            className: "body-item"
          }, body));
        }

        return null;
      }), this.props.model.showArrows && /*#__PURE__*/_react.default.createElement(_a11y.Buttonize, {
        onClick: this.props.model.nextTab,
        label: "Navigate to Next Tab"
      }, /*#__PURE__*/_react.default.createElement("li", {
        className: "arrow next-tab"
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "icon-right-open"
      }))))), !this.props.renderBodyAsListItem && body);
    }
  }], [{
    key: "defaultProps",
    value: function defaultProps() {
      return {
        renderBodyAsListItem: false
      };
    }
  }]);

  return TabbedSection;
}(_react.default.Component), _defineProperty(_class2, "propTypes", {
  model: _propTypes.default.instanceOf(_TabbedSectionModel.default).isRequired,
  className: _propTypes.default.string,
  renderBodyAsListItem: _propTypes.default.bool
}), _defineProperty(_class2, "contextType", _ActionRoot.ActionRootContext), _class2)) || _class;

TabbedSection.Tab = (0, _createReactClass.default)({
  displayName: "Tab",
  propTypes: {
    index: _propTypes.default.number.isRequired,
    isActive: _propTypes.default.bool.isRequired,
    isDisabled: _propTypes.default.bool,
    isHidden: _propTypes.default.bool,
    className: _propTypes.default.string,
    onClick: _propTypes.default.func.isRequired,
    onChangeTab: _propTypes.default.func
  },
  getDefaultProps: function getDefaultProps() {
    return {
      isDisabled: false,
      isHidden: false,
      isActive: false,
      onClick: _noop.default
    };
  },
  render: function render() {
    var classes = (0, _classnames.default)(this.props.className, "tabbed-section-tab", this.props.isActive && !this.props.isDisabled && "selected", // add the selected class if this is the tab for the active tab
    this.props.isDisabled && "disabled" // add the selected class if this is the tab for the active tab
    );

    if (!this.props.isHidden) {
      return /*#__PURE__*/_react.default.createElement(_a11y.Buttonize, {
        onClick: this.props.onClick,
        label: "Tab ".concat(this.props.index),
        pressed: this.props.isActive
      }, /*#__PURE__*/_react.default.createElement("li", {
        className: classes,
        key: "tab-" + this.props.index
      }, this.props.children));
    }

    return /*#__PURE__*/_react.default.createElement("li", null);
  }
});
TabbedSection.Panel = (0, _createReactClass.default)({
  displayName: "Panel",
  propTypes: {
    index: _propTypes.default.number.isRequired,
    isHidden: _propTypes.default.bool,
    className: _propTypes.default.string
  },
  getDefaultProps: function getDefaultProps() {
    return {
      isHidden: false
    };
  },
  render: function render() {
    if (!this.props.isHidden) {
      var classes = (0, _classnames.default)("tabbed-section-panel", this.props.className);
      return /*#__PURE__*/_react.default.createElement("div", {
        className: classes,
        key: "panel-" + this.props.index
      }, this.props.children);
    }

    return /*#__PURE__*/_react.default.createElement("div", null);
  }
});
var _default = TabbedSection;
exports.default = _default;